import { render, staticRenderFns } from "./Create3.vue?vue&type=template&id=578a6d81"
import script from "./Create3.vue?vue&type=script&lang=js"
export * from "./Create3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('578a6d81')) {
      api.createRecord('578a6d81', component.options)
    } else {
      api.reload('578a6d81', component.options)
    }
    module.hot.accept("./Create3.vue?vue&type=template&id=578a6d81", function () {
      api.rerender('578a6d81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/cards/Create3.vue"
export default component.exports